module.exports = __webpack_public_path__ + "media/images/policies/redirect_popup/creditcard-company-3-1d08fbc2bbd68415c9d6db90da3fdbd7.png";